<template>
  <v-container id="dashboard" fluid tag="section">
    <v-row>
      <v-col cols="12" sm="6" lg="4">
        <base-material-stats-card
          color="info"
          icon="mdi-shopping"
          title="Pedidos"
          :value="numPedidosTotal[0]"
          sub-icon="mdi-clock"
          sub-text="En el día de hoy"
        />
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <base-material-stats-card
          color="success"
          icon="mdi-currency-eur"
          title="Cantidad"
          :value="numPedidosTotal[1]"
          sub-icon="mdi-clock"
          sub-text="En el día de hoy"
        />
      </v-col>

      <v-col cols="12" sm="6" lg="4">
        <base-material-stats-card
          color="primary"
          icon="mdi-poll"
          title="Negocios"
          :value="numPedidosTotal[0].toString()"
          sub-icon="mdi-home"
          sub-text="Negocios del directorio"
        />
      </v-col>
    </v-row>
    <listado-pedidos :pedidosBruto="pedidosTabla" />
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { mostrarMoneda } from "@/utils/utils.js";
import moment from "moment-timezone";
import ListadoPedidos from "../../components/ListadoPedidos.vue";

export default {
  components: { ListadoPedidos },
  data() {
    return {
      search: "",
      loading: false,
      headers: [
        {
          sortable: false,
          text: "Pedido Restaurante",
          value: "numPedidoRest",
        },
        {
          sortable: false,
          text: "Fecha",
          value: "fecha",
        },
        {
          sortable: false,
          text: "Modo",
          value: "modo",
        },
        {
          sortable: false,
          text: "Forma de pago",
          value: "forma_pago",
        },
        {
          sortable: false,
          text: "Cantidad",
          value: "cantidad",
        },
        {
          sortable: false,
          text: "Restaurante",
          value: "nombreRest",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      pedidosBruto: (state) => state.pedidos.pedidosArray,
    }),
    pedidosPadre() {
      return this.pedidosBruto.filter((p) => !!p.multipleHijos);
    },
    pedidosHijos() {
      return this.pedidosBruto.filter((p) => !!p.multipleEsHijo);
    },
    pedidosTabla() {
      let res = [];
      console.log(this.pedidosPadre);
      return this.pedidosBruto.map((p) => {
        return {
          ...p,
          nombreRest: p.copyNegocio.nombre + " " + p.copyRest.nombre,
          cantidad: mostrarMoneda(p.precioTotal),
          fecha: moment(p.fechaServidor.toDate()).format("HH:mm"),
        };
      });
    },
    numPedidosTotal() {
      console.log(this.pedidosPadre);
      let total = this.pedidosPadre
        .filter((p) => !p.eliminado)
        .reduce((acc, val) => acc + parseFloat(val.precioTotal), 0);
      let numPedidos = this.pedidosPadre.filter((p) => !p.eliminado).length;

      return [numPedidos.toString(), mostrarMoneda(total)];
    },
  },
  mounted() {},
};
</script>

<style>
</style>